import React from 'react'
import { Box, Typography } from '@mui/material'
import type { DrawerViewProps } from '@app/src/components/Drawer/DrawerView'
import DrawerView from '@app/src/components/Drawer/DrawerView'
import { useIntl } from 'react-intl'

type ConnectionStatusesDrawerProps = Omit<DrawerViewProps, 'title'>

export const ConnectionStatusesDrawer: React.FC<ConnectionStatusesDrawerProps> = props => {
  const { formatMessage } = useIntl()

  return (
    <DrawerView
      title={formatMessage({ id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.title' })}
      disableScrolling
      showBackButton={false}
      {...props}
    >
      <Box
        sx={{
          px: 3,
          height: '100%',
          overflow: 'auto',
        }}
        tabIndex={-1}
      >
        <Box mb={3}>
          <Typography variant="subtitle1" color="text.primary" mb={1}>
            {formatMessage({ id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.connected.title' })}
          </Typography>
          <Typography variant="body1">
            {formatMessage({
              id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.connected.description',
            })}
          </Typography>
        </Box>

        <Box mb={3}>
          <Typography variant="subtitle1" color="text.primary" mb={1}>
            {formatMessage({
              id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.notConnected.title',
            })}
          </Typography>
          <Typography variant="body1">
            {formatMessage({
              id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.notConnected.description',
            })}
          </Typography>
        </Box>

        <Box mb={3}>
          <Typography variant="subtitle1" color="text.primary" mb={1}>
            {formatMessage({ id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.inviteSent.title' })}
          </Typography>
          <Typography variant="body1">
            {formatMessage({
              id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.inviteSent.description',
            })}
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle1" color="text.primary" mb={1}>
            {formatMessage({
              id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.missingContact.title',
            })}
          </Typography>
          <Typography variant="body1">
            {formatMessage({
              id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.missingContact.description',
            })}
          </Typography>
        </Box>
      </Box>
    </DrawerView>
  )
}
